/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getUrlSync } from '@msdyn365-commerce/core';
import { ICartIconViewProps, ICartViewProps } from '@msdyn365-commerce-modules/cart';
import { Node } from '@msdyn365-commerce-modules/utilities';
import React from 'react';

/**
 *
 * CartIconView component.
 * @extends {React.PureComponent<ICartIconViewProps>}
 */
export class CartIconView extends React.PureComponent<
    ICartViewProps & ICartIconViewProps
> {
    /**
     * Render Cart Item count.
     * @returns JSX Element.
     */
    public render(): JSX.Element | null {
        return (
            <Node {...this.props.miniCartWrapper} {...this.props.renderModuleAttributes(this.props)}>
                <a href={getUrlSync('cart', this.props.context.actionContext)} className='ms-cart-icon-wrapper msc-btn'>
                    {this.props.cartIcon}
                </a>
            </Node>
        );
    }
}

export default CartIconView;
